import { axios } from '~/clients';
import SearchType from '~/constants/common/SearchType';
import { GET_SUGGESTIONS_V3 } from '~/constants/endpoints';
import { Suggestion } from '~/contracts/common';
import { normalizeSearchInputShape } from './utils';

export default async function fetchSuggestions(inputValue: string) {
  if (inputValue.trim().length === 0) return [];

  const response = await axios.get<{ suggestions: Suggestion[] }>(
    `${GET_SUGGESTIONS_V3}?FilterResponseVersion=v2&query=${inputValue}`
  );

  const keywordSuggestions = response?.data?.suggestions || [];

  return normalizeSearchInputShape({
    userInput: inputValue,
    searchInputType: SearchType.TextSearch,
    data: keywordSuggestions
  });
}
